
import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { IAttributes } from 'src/app/models/IAttributes';
import { IInsuranceDetails } from 'src/app/models/IInsuranceDetails';
import { ILocationDetails } from 'src/app/models/ILocationDetails';
import { IMessage } from 'src/app/models/IMedicationHistoryDTO';
import { MessageInbox } from 'src/app/models/IMessaging';
import { MessagesService } from 'src/app/Services/Messages/messages.service';
import { RxService } from 'src/app/Services/NewVisitNote/rx.service';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { IPersonalInfo } from 'src/app/models/IPersonalInfo';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
@Component({
  selector: 'app-patient-ammendments-note',
  templateUrl: './patient-ammendments-note.component.html',
  styleUrls: ['./patient-ammendments-note.component.css']
})
export class PatientAmmendmentsNoteComponent implements OnInit {

  PatientAmmendmentForm: FormGroup;
  patientName: string = "";
  providerName: string = "";
  ammendmentNotes: string = "";
  requestedDate: string = "";



  Notes: string = "";
  rejectedBy: string = '';
  rejectedDate: string = '';

  constructor(private formBuilder: FormBuilder, private toastr: ToastrService,
    private messageService: MessagesService, private router: Router,
    private route: ActivatedRoute, private rxService: RxService,
    private sharedService: SharedService, public dialog: MatDialog) {

  }
  public linkID: string = '0';
  ngOnInit() {
    ;
    this.PatientAmmendmentForm = this.formBuilder.group({
      rejectNotes: ['', Validators.required],
      rejectReason: [''],
      acceptedNotes: [''],
      rejectAccept: ['']

    })
    this.linkID = this.route.snapshot.paramMap.get('linkId');
    this.getPatientRequestDetails();
  }
  lstPatientRequestInformation: IInsuranceDetails;

  isDisableRejectReason: boolean = false;
  requestStatus: string = '';
  MSuffix: string = "";
  isVisableRejectreason: boolean = false;
  isVisableAccepted: boolean = false;
  isVisableRejectedBy: boolean = false;
  isVisableAcceptedBy: boolean = false;
  isDisableDemographicsbutton: boolean = false;


  maxChars = 230;
  charCount = '';
  charCount1 = '';
  isPatientStatus: boolean = false;
  patientId: number = 0;
  hideRejectbutton: boolean = true;
  hideRejectReason: boolean = true;
  hideAccept: boolean = true;
  rejectNotes: string = '';
  dpatId: string;
  IsDisableAccept: boolean = true;
  isVisableAccept: boolean = true;
  isVisableReject: boolean = true;
  getPatientRequestDetails() {
    this.sharedService.getAmmendmentNoteInformation('', 'Message', this.linkID)
      .subscribe(
        (ammendment: any) => {
          if (ammendment.length > 0) {
            //alert(ammendment[0].acceptNotes)
            this.dpatId = ammendment[0].patientId;
            this.requestStatus = ammendment[0].status;
            this.patientName = ammendment[0].patientName;
            this.ammendmentNotes = ammendment[0].ammendmentNotes;
            this.requestedDate = ammendment[0].createdOn;
          }
          if (ammendment[0].status == 'Rejected') {
            this.hideRejectbutton = false;
            this.hideRejectReason = true;
            this.PatientAmmendmentForm.patchValue({
              rejectNotes: ammendment[0].comments,
              rejectReason: true
            })
            this.rejectNotes = ammendment[0].comments;
            this.isVisableRejectedBy = true;
            this.charCount = ammendment[0].comments;
            this.rejectedBy = ammendment[0].createdBy + '   ' + ammendment[0].createdOn;
            this.rejectedDate = this.rejectedDate;
            this.isVisableRejectreason = true;
            this.isDisableRejectReason = true;
            this.isDisableDemographicsbutton = true;
            this.isVisableAccept = false;
          }
          if (ammendment[0].status == 'Completed') {
            this.isVisableReject = false;
            this.isVisableAccept = true;;
            this.hideRejectbutton = false;
            this.hideRejectReason = true;
            this.isVisableAccepted = true;
            this.isDisableRejectReason = true;
            this.isDisableDemographicsbutton = true;
            this.isVisableAcceptedBy = true;
            this.isPatientStatus = true;
            this.rejectedBy = ammendment[0].modifiedBy + '   ' + ammendment[0].modifiedOn;
            this.charCount1 = ammendment[0].acceptNotes;
            this.PatientAmmendmentForm.patchValue({
              acceptedNotes: ammendment[0].acceptNotes,
              rejectAccept: true,
            })
          }

        },
        (err: any) => {
          console.log(err);
        });
  }


  onClick_backToMessages() {
    // this.router.navigate(['messageInbox']);
    this.router.navigate(['tasksandmessages/', 'BackToMessages']);
  }


  rejectRequestInfo: MessageInbox;
  onClick_Accept_Reject(type: string) {
    var commenttext, displayMessage;
    if (type == "Completed") {
      this.isVisableAccepted = true;
      //this.hideRejectReason = false;
      commenttext = this.PatientAmmendmentForm.value.acceptedNotes;

      displayMessage = "Please Enter Accept Comments";
    } else {
      commenttext = this.PatientAmmendmentForm.value.rejectNotes;
      displayMessage = "Please Enter Reject Comments";
    }
    if (this.linkID != undefined || this.linkID != null) {

      if (commenttext == "") {
        this.toastr.error(displayMessage);
        return false;
      } else {
        this.sharedService.UpdateAmmendmentStatus(this.linkID, type, commenttext, type).subscribe(
          (data: any) => {
            this.toastr.success(data);
            //this.router.navigate(['messageInbox']);
            this.router.navigate(['tasksandmessages/', 'BackToMessages']);
          },
          (err: any) => {
            console.log(err);
          });
      }

    }
  }

  changeReasonforReject(event: any) {
    if (event.target.checked) {
      this.isVisableRejectreason = true;
      this.isDisableDemographicsbutton = true;
      this.isVisableAccepted = false;

      this.PatientAmmendmentForm.patchValue({
        acceptedNotes: "",
        rejectAccept: false
      })
    }
    else {
      this.PatientAmmendmentForm.patchValue({
        rejectNotes: ''
      })
      this.isVisableRejectreason = false;
      this.isDisableDemographicsbutton = false;
    }
  }
  changeReasonforAccept(event: any) {
    if (event.target.checked) {
      this.isVisableRejectreason = false;
      this.isDisableDemographicsbutton = false;
      this.isVisableAccepted = true;
      this.IsDisableAccept = false;

      this.PatientAmmendmentForm.patchValue({
        rejectNotes: "",
        rejectReason: false
      })
    }
    else {
      this.PatientAmmendmentForm.patchValue({
        acceptedNotes: ''
      })
      this.isVisableAccepted = false;
      this.isDisableDemographicsbutton = true;
    }
  }
}


